<script setup lang="ts">
import type { EncounterMeta } from "../lib/types";
import Duration from "./Duration.vue";

defineProps<{ encounters: EncounterMeta[]; selected: number | null }>();
defineEmits<{ select: [index: number] }>();

const DIFF: Record<number, string> = { 14: "N", 15: "H", 16: "M", 17: "LFR" };
</script>

<template>
  <ul class="space-y-1">
    <li v-for="e in encounters" :key="e.index">
      <button
        class="w-full rounded px-2 py-2 text-left text-sm"
        :class="selected === e.index ? 'bg-zinc-800' : 'hover:bg-zinc-900'"
        @click="$emit('select', e.index)"
      >
        <div class="flex items-center gap-2">
          <span class="truncate font-medium">{{ e.name }}</span>
          <span class="ml-auto rounded bg-zinc-700 px-1 text-[10px] text-zinc-300">
            {{ DIFF[e.difficulty] ?? e.difficulty }}
          </span>
        </div>
        <div class="mt-0.5 flex items-center gap-2 text-xs text-zinc-500">
          <Duration :timestamp="e.duration_ms" />
          <span :class="e.success ? 'text-emerald-400' : 'text-red-400'">
            {{ e.in_progress ? "live" : e.success ? "kill" : "wipe" }}
          </span>
        </div>
      </button>
    </li>
  </ul>
</template>
